import type { RefObject } from "react";

export const SCOREBOARD_SCROLL_CONTAINER_CLASS = "scoreboard-container";

/**
 * Scrolls an element into view within a nested overflow container (not the window).
 */
export function scrollElementWithinContainer(
    element: HTMLElement,
    container: HTMLElement,
    options?: { behavior?: ScrollBehavior },
): void {
    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const relativeTop = elementRect.top - containerRect.top + container.scrollTop;
    const targetTop = relativeTop - container.clientHeight / 2 + element.clientHeight / 2;
    container.scrollTo({
        top: Math.max(0, targetTop),
        behavior: options?.behavior ?? "smooth",
    });
}

/**
 * Resolves the puzzle scoreboard scroll container from a ref or DOM query fallback.
 */
export function resolveScoreboardScrollContainer(
    containerRef?: RefObject<HTMLElement | null>,
): HTMLElement | null {
    if (containerRef?.current) {
        return containerRef.current;
    }
    const fallback = document.querySelector(`.${SCOREBOARD_SCROLL_CONTAINER_CLASS}`);
    return fallback instanceof HTMLElement ? fallback : null;
}
